<template>
  <!-- DELETE PROCESS -->
  <div class="alert alert-warning d-flex align-items-start fs-md-15 fs-lg-16 gap-3 mb-30 show" role="alert"
    :class="{ 'cursor-pointer': show_link }" @click="redirect">
    <i class="ph-duotone ph-warning-diamond fs-25"></i>
    <div>
      <p class="mb-0" v-html="$t('feature.auth.$delete_account.process_pending_warning', {
        patient_full_name: `${patient.firstname ?? ''} ${patient.lastname ?? ''}`,
      })
        "></p>
      <template v-if="show_link">
        <div class="d-inline-flex text-decoration-none lh-1 fw-medium gap-1 align-items-center ms-auto mt-10">
          {{ $t("cta.view") }}
          <i class="ph-duotone ph-caret-right text-black fs-16 lh-1"></i>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { PatientInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "PatientCancellationWarning",
  props: {
    patient: {
      type: Object as PropType<PatientInfo>,
      required: true,
    },
    show_link: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirect(): void {
      if (this.show_link) {
        this.$router.push(`/patient/${this.patient.id}`);
      }
    },
  },
});
</script>
